const isObject = (obj: any) =>
  Object.getPrototypeOf(obj) === Object.prototype

const isEmptyArray = (arr: any) => Array.isArray(arr) && arr.length === 0

const isEmptyObject = (obj: any) =>
  isObject(obj) &&
  Object.keys(obj).length === 0

export const isNullOrEmpty = (val: any): val is null | undefined | '' | 'undefined' => {
  return (
    val === null ||
    val === '' ||
    val === undefined ||
    val === 'undefined' ||
    isEmptyArray(val) ||
    isEmptyObject(val)
  )
}